<script setup>
import { computed } from 'vue';
import FormSelect from 'v3/components/Form/Select.vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  value: {
    type: String,
    default: 'original',
  },
  label: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['change']);

const { t } = useI18n();

const translationOptions = computed(() => [
  {
    value: 'original',
    label: t(
      'PROFILE_SETTINGS.FORM.INTERFACE_SECTION.MESSAGE_TRANSLATION.ORIGINAL'
    ),
  },
  {
    value: 'translated',
    label: t(
      'PROFILE_SETTINGS.FORM.INTERFACE_SECTION.MESSAGE_TRANSLATION.TRANSLATED'
    ),
  },
]);

const selectedValue = computed({
  get: () => props.value,
  set: value => {
    emit('change', value);
  },
});
</script>

<template>
  <div class="flex gap-2 justify-between w-full items-start">
    <div>
      <label class="text-n-gray-12 font-medium leading-6 text-sm">
        {{ label }}
      </label>
      <p class="text-n-gray-11">
        {{ description }}
      </p>
    </div>
    <FormSelect
      v-model="selectedValue"
      name="messageTranslation"
      spacing="compact"
      class="min-w-28 mt-px"
      :value="selectedValue"
      :options="translationOptions"
      label=""
    >
      <option
        v-for="option in translationOptions"
        :key="option.value"
        :value="option.value"
        :selected="option.value === selectedValue"
      >
        {{ option.label }}
      </option>
    </FormSelect>
  </div>
</template>
